import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core'
import classname from 'classnames'

import { PATHS } from '../../../../Config/Routing/paths'
import StyledBreadcrumbs from '../../../../Components/StyledBreadcrumbs'
import { PageTitle } from '../../../../Components/PageTitle'
import ArrowBackIcon from '../../icons/ArrowBackIcon'
import injectStyles from 'react-jss'
import { styles } from '../../styles'
import BreadcrumbsSettingsIcon from '../../../../Assets/Images/icons/breadcrumbsSettings'
import DropZoneArea from '../../../Campaigns/Page/Codes/components/Popups/CodeUploadPopups/DropZoneArea'
import { parseCSV } from '../../../../Utils/Misc'
import ExampleCSVIcon from '../../icons/ExampleCSVIcon'

const useStyles = makeStyles(() => ({
  exampleWrapper: {
    background: '#EDEDFF',
    height: '92px',
    width: '100%',
    marginTop: '20px',
    border: '8px',
    padding: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  exampleText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  exampleTitle: {
    color: '#00112B',
    fontWeight: 700,
    fontSize: '16px',
  },
  exampleDescription: {
    color: '#00112B',
    fontWeight: 400,
    fontSize: '16px',
  },
  exampleContent: {
    display: 'flex',
    '& > svg': {
      marginRight: '20px',
    },
  },
  buttonDownload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '180px',
    height: '32px',
    borderRadius: '12px',
    border: '1px solid #273754',
    fontSize: '16px',
    lineHeight: '20px',
    fontWeight: 700,
    background: '#FFFFFF',
    cursor: 'pointer',
    '&:hover': {
      color: '#FFFFFF',
      background: '#004360',
      border: `1px solid #004360`,
    },
    '&:active': {
      color: '#FFFFFF',
      background: '#D72B4F',
      border: `1px solid #D72B4F`,
    },
  },
  buttonNext: {
    fontFamily: "'Proxima Nova', sans-serif",
    borderRadius: '12px',
    backgroundColor: '#004360',
    color: '#FFFFFF',
    textTransform: 'none',
    border: '1px solid #004360',
    minWidth: '200px',
    padding: '7px 20px',
    fontWeight: 700,

    '&:hover': {
      color: '#004360',
      background: '#FFFFFF',
      border: `1px solid #004360`,
    },
    '&:active': {
      color: '#FFFFFF',
      background: '#D72B4F',
      border: `1px solid #D72B4F`,
    },
  },
  buttonWrap: {
    marginTop: '56px',
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
}))

const CSVUpload = ({ classes: sharedClasses }) => {
  const history = useHistory()
  const classes = useStyles()

  // eslint-disable-next-line no-unused-vars
  const [isLoading, setIsLoading] = useState(false)

  const onBack = () => {
    history.push(
      `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
        PATHS.clientSettings.coupons
      }`,
    )
  }
  const onFileUpload = async files => {
    try {
      setIsLoading(true)
      const parsedData = await parseCSV(files[0])

      // eslint-disable-next-line no-unused-vars
      const { data: rows } = parsedData
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  const onClickDownload = () => {}

  const onClickNext = () => {}

  return (
    <div className={classname(sharedClasses.container)}>
      <StyledBreadcrumbs
        icon={<BreadcrumbsSettingsIcon />}
        breadcrumbs={[
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}`,
            label: 'Settings',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.coupons
            }`,
            label: 'Coupons',
          },
          {
            link: `${PATHS.main.dashboard}${PATHS.dashboard.clientSettings}${
              PATHS.clientSettings.coupons
            }${PATHS.clientSettings.createCoupon}`,
            label: 'Create Coupon',
          },
          {
            label: 'CSV Upload',
          },
        ]}
      />
      <PageTitle className={sharedClasses.title}>
        <div className={sharedClasses.back} onClick={onBack}>
          <ArrowBackIcon />
        </div>
        <div>CSV upload</div>
      </PageTitle>
      <div className={sharedClasses.description}>
        Upload your list of coupons
      </div>
      <DropZoneArea onFileUpload={onFileUpload} />
      <div className={classes.exampleWrapper}>
        <div className={classes.exampleContent}>
          <ExampleCSVIcon />
          <div className={classes.exampleText}>
            <div className={classes.exampleTitle}>Download template</div>
            <div className={classes.exampleDescription}>
              You can download our template, with an example and use them as a
              starting point
              <br /> for your own file.
            </div>
          </div>
        </div>
        <button onClick={onClickDownload} className={classes.buttonDownload}>
          Download
        </button>
      </div>
      <div className={classes.buttonWrap}>
        <button onClick={onClickNext} className={classes.buttonNext}>
          Next
        </button>
      </div>
    </div>
  )
}

export default injectStyles(styles)(CSVUpload)
